import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { GusQuery, GusQueryState, GusQueryType } from 'src/lib/fliko/models/integrations/gusQuery.data';
import { Nullish } from 'src/lib/fliko/types/typeish.type';
import { ContextDataService } from 'src/app/view/user-context/services/context.data-service';
import { DatabaseService } from '../../services/database.service';

@Injectable({ providedIn: 'root' })
export class GusQueryService {
  private estateId: string;

  constructor(
    private dbSrv: DatabaseService,
    private ctxDS: ContextDataService
  ) {
    this.estateId = this.ctxDS.peekCurrentEstateId();
  }

  /**
   * @path /gusQuery/$userId/
   */
  private get gusQuery() {
    return this.dbSrv.commonFactory.getObject<GusQuery>('gusQuery/$userId');
  }

  public sendNipQueryToGus(userId: string, nip: string): Promise<void> {
    const query: GusQuery = {
      userId: userId,
      estateId: this.estateId,
      createDate: Date.now(),
      state: GusQueryState.CREATED,
      query: { type: GusQueryType.GET_NIP, param: nip }
    };
    return this.gusQuery.set(query);
  }

  public sendLogoutQueryToGus(): Promise<void> {
    return this.gusQuery.updateChild('query', { type: GusQueryType.LOGOUT });
  }

  public getGusQuery$(): Observable<GusQuery | Nullish> {
    return this.gusQuery.get();
  }
}
